import { render } from "./DataImportVx.vue?vue&type=template&id=8c300b68&scoped=true"
import script from "./DataImportVx.vue?vue&type=script&lang=js"
export * from "./DataImportVx.vue?vue&type=script&lang=js"

import "./DataImportVx.vue?vue&type=style&index=0&id=8c300b68&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c300b68"]])

export default __exports__